
class WheelchairQuantitySelect {
  /**
   * Note this class is essentially a noop if it's instantiated
   * without a select element.
   *
   * @param {HTMLSelectElement} select
   */
  constructor(select) {
    this.select = select;
  }

  /**
   * @param {number} maxQuantity
   */
  updateMaxQuantity(maxQuantity) {
    const { select } = this;

    if (!select) {
      return;
    }

    const currentQuantity = this.getSelectedQuantity();
    const newValue = Math.min(currentQuantity, maxQuantity);

    Array.from(select.children).forEach(option => select.removeChild(option));

    for (let i = 0; i <= maxQuantity; i += 1) {
      const option = document.createElement('option');
      option.value = i;
      option.text = i;
      option.selected = i === newValue;

      select.appendChild(option);
    }

    select.disabled = maxQuantity < 1;
  }

  getSelectedQuantity() {
    const { select } = this;

    if (!select) {
      return 0;
    }

    return parseInt(select.value || 0, 10);
  }
}

export default WheelchairQuantitySelect;



// WEBPACK FOOTER //
// ./src/events/detail/WheelchairQuantitySelect.js